import ApiService from '../ApiService'

const DayClosureService = {

    postGenerateReport(date) {
        return ApiService.post(`day-closure/generate-Report/?shippingDate=${date}`)
    },

    getDayClosures(userId) {
        return ApiService.get(`/day-closure?userId=${userId}`);
    },

    getSummary(userId, date) {
        return ApiService.get(`/day-closure/summary?userId=${userId}&date=${date}`);
    },

    getReturns(userId, date) {
        return ApiService.get(`/day-closure/returns?userId=${userId}&date=${date}`);
    },

    getMissingDocuments(userId, date) {
        return ApiService.get(`/day-closure/missing-documents?userId=${userId}&date=${date}`);
    },

    getTotals(userId, date) {
        return ApiService.get(`/day-closure/totals?userId=${userId}&date=${date}`);
    },

    getShippingFeeTotal(userId, date) {
        return ApiService.get(`/day-closure/shipping-fee-total?userId=${userId}&date=${date}`);
    },

    registerReturn(userId, date, stickerData) {
        return ApiService.post(
            `/day-closure/registerReturn`,
            { userId, date, sticker: stickerData }
        );
    },

    registerDelivered(userId, date, barcode) {
        return ApiService.post(
            `/day-closure/registerDelivered`,
            { userId, date, barcode }
        );
    },

    saveDayClosure(idOrder, userId, date) {
        return ApiService.post(
            `/day-closure`,
            { idOrder, userId, date }
        );
    },
    cancelReturn(date, code) {
        return ApiService.post(`/day-closure/cancel-return`, { date, code });
    },
    cancelReturns(data) {
        return ApiService.post(`/day-closure/cancel-returns`, { data });
    }
}

export default DayClosureService;
